import React, { useState } from 'react';
import { Dropdown, Tooltip } from 'antd';
import { MoreOutlined, LineChartOutlined, LogoutOutlined } from '@ant-design/icons';
import './Styles.css';

const MenuMaisOpcoes = (props) => {
  const [abrirMenu, setAbrirMenu] = useState(false);
  const [clique, setClique] = useState(false);

  const onItemClick = ({ key }) => {
    setAbrirMenu(false);
    if (props.onItemClick) {
      props.onItemClick(key, props.user);
    }
  };

  const handleClick = () => {
    setClique(true);
    setTimeout(() => {
      setClique(false);
    }, 150);
  };

  const items = [
    {
      key: 'ranking',
      label: 'Meu Desempenho',
      icon: <LineChartOutlined />,
    },
    {
      key: 'sair',
      label: 'Sair da Fila',
      danger: true,
      icon: <LogoutOutlined />,
    },
  ];

  const anchorClass = `ant-dropdown-link div-container-menu-mais-opcoes ${clique ? 'clicked' : ''}`;

  return (
    <Dropdown
      menu={{ items, onClick: onItemClick }}
      open={abrirMenu}
      onOpenChange={setAbrirMenu}
      trigger={['click']}
    >
      <Tooltip title="Mais opções">
        <span onClick={handleClick} className={anchorClass} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleClick()}>
          <MoreOutlined className="menu-mais-opcoes" />
        </span>
      </Tooltip>
    </Dropdown>
  );
};

export default MenuMaisOpcoes;
